import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "max-w-lg mx-auto text-left p-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-londrina" }, "Nominations", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2 mb-8 font-pt-root font-medium" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-yusei" }, "ノミネート作品", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2 mb-8" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lang === 'en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (key) => {
        return (_openBlock(), _createElementBlock("iframe", {
          key: key,
          class: "mb-1",
          width: "480",
          height: "270",
          src: `https://www.youtube.com/embed/${key}`,
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, "\n      ", 8, _hoisted_10))
      }), 128))
    ])
  ]))
}